// Chorus-fruit teleport (DIM-3). PURE (ENG-1).
//
// Chorus fruit shipped as ordinary food — 4 hunger and nothing else — which made the
// End's one renewable crop indistinguishable from an apple. Eating one should blink
// you a short way, and that is what makes chorus forests worth harvesting: a bag of
// fruit is a way off a shard you got stranded on.
//
// The search follows Minecraft: sample a random offset box around the eater, then
// FALL from the sampled height to the first floor under it, so a roll into open air
// still lands you somewhere sensible instead of being thrown away.
import { CHORUS } from '../config';

/** What the search needs to know about the world. */
export interface ChorusAccess {
  isSolid(x: number, y: number, z: number): boolean;
}

/**
 * Where eating a chorus fruit puts you (feet position), or null when no attempt
 * found a standable spot — the fruit is still eaten in that case, as in Minecraft;
 * you simply do not move. `roll()` supplies 0..1 values (three per attempt), so the
 * host decides whether the jump is deterministic.
 */
export function chorusTeleportTarget(
  access: ChorusAccess,
  x: number,
  y: number,
  z: number,
  roll: () => number,
): [number, number, number] | null {
  const R = CHORUS.TELEPORT_RANGE;
  const offset = (): number => Math.floor(roll() * (2 * R + 1)) - R;
  const fx = Math.floor(x), fy = Math.floor(y), fz = Math.floor(z);
  for (let i = 0; i < CHORUS.TRIES; i++) {
    const tx = fx + offset(), tz = fz + offset(), top = fy + offset();
    for (let ty = top; ty >= top - CHORUS.DROP; ty--) {
      // A floor underfoot and two blocks of headroom — the same standable test the
      // enderman blink uses, so neither can strand you inside a wall.
      if (access.isSolid(tx, ty - 1, tz) && !access.isSolid(tx, ty, tz) && !access.isSolid(tx, ty + 1, tz)) {
        return [tx + 0.5, ty, tz + 0.5];
      }
    }
  }
  return null;
}

/** Does eating this item blink the eater? (The fruit does; the popped one does not
 *  — it is a smelted crafting ingredient and not food at all.) */
export function teleportsOnEat(item: string): boolean {
  return item === 'chorus_fruit';
}
